import {ReactNode, RefObject} from "react";

import "./Form.css"

/**
 * The props for this component
 */
interface FormPanelProps {
  title: string,
  children: ReactNode,
  panelReference?: RefObject<HTMLDivElement>
  //TODO This component will include a future prop to indicate if it's a write only, read only, or read and write component
}

/**
 * This is a wrapper panel to help organise a form into sections. To make use of this panel please include the following
 * props:
 *
 * @param title The title of the panel.
 * @param children This will be the body of the form where the actual fields will reside.
 * @param panelReference This is an optional reference that is used to provide useRef functionality to the panel div
 */
export default function FormPanel({title, children, panelReference}: FormPanelProps) {
  /*
   * This will be used to give each instance of this component a unique ID based on its title. It will replace spaces
   * with _
   */
  let componentTitleForId = `_${title.toLowerCase().replace(' ', '_')}`;

  return <div id={`formPanel${componentTitleForId}`} className={"formPanel"} ref={panelReference}>
    <div id={`formPanelTitle${componentTitleForId}`} className={"formPanelTitle"}>
      {title}
    </div>
    <div id={`formPanelContent${componentTitleForId}`} className={"formPanelContent"}>
      {children}
    </div>
  </div>
}